export const STOREBRAND_PHONE_NUMBER = {
  telString: '915 08 880',
  telNumber: 91508880,
  href: 'tel:004791508880',
};

export const DANSKE_BANK_PHONE_NUMBER = {
  telString: '+47 22 31 20 01',
  telNumber: 22312001,
  href: 'tel:004722312001',
};

export const AKADEMIKERNE_PHONE_NUMBER = {
  telString: '67 51 93 00',
  telNumber: 67519300,
  href: 'tel:004767519300',
};

export const COOP_PHONE_NUMBER = {
  telString: '22 31 10 60',
  telNumber: 22311060,
  href: 'tel:004722311969',
};
